import { MsgExecuteContract } from "@goblinhunt/cosmes/client";

export async function transferNft(
  wallet,
  fromAddress, 
  recipientAddress, 
  nftAddress, 
  tokenId, 
  nftName
) {
    const fixedFeeAmount = (50 * 1_000_000).toFixed(0); 
    const messages = [
        new MsgExecuteContract({
          sender: fromAddress, 
          contract: nftAddress,
          msg: {
            transfer_nft: {
              recipient: recipientAddress,
              token_id: tokenId,
            },
          },
          funds: [],
        }),
      ];

      const tx = {
        msgs: messages,
        memo: 'Sent Via Lunc Tools NFT Platform',
      };
    
      const fee = await wallet.estimateFee(tx, 2.0);
      const txHash = await wallet.broadcastTx(tx, fee);
      
        const logEntry = {
          hash: txHash,
          name: nftName,
          from: fromAddress,
          timestamp: new Date().toISOString(),
        };
        
        await fetch('/log-tx.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(logEntry),
        });

      return txHash;
    }
